module.exports = __webpack_public_path__ + "img/target-02.fa810e4e.svg";